import Images from '@assets/images';
import { Accordion, Chip, Divider, Typography } from '@components/base';
import { Avatar } from '@components/common';
import { useState } from 'react';
import css from './index.module.scss';
import { ITaskTabProps } from '@helpers/types/task-tabs';
import Footer from '../components/footer';
import { Link } from 'react-router-dom';
import AddProofOfDeliveryModal from './components';

interface addProofOfDeliveryProps {
  taskData: Partial<ITaskTabProps>;
  onComplete?: () => void;
}

const AddProofOfDelivery = (props: addProofOfDeliveryProps) => {
  const [openModal, setopenModal] = useState(false);
  const getCompleteStatus = props.taskData.is_completed;
  const [taskIsCompleted, setTaskIsCompleted] = useState<boolean | undefined>(getCompleteStatus);
  const { taskData } = props;

  const handleStatusFromModal = (data: boolean) => {
    setTaskIsCompleted(data);
  };

  return (
    <>
      <div className={css.mainWrapper}>
        <Accordion defaultExpanded>
          <Accordion.Header className={css.accordionHeader}>
            <div className={css.header}>
              <div className={css.wrapper}>
                {getCompleteStatus || taskIsCompleted ? (
                  <Avatar src={Images.alertSuccessFaint} alt="" />
                ) : (
                  <Avatar src={Images.illustration} alt="" />
                )}

                <Link to={`/order/${taskData?.order}`} style={{ textDecoration: 'none' }}>
                  <Typography variant="h5" className={css.underlineOnHover}>
                    #{taskData?.readable_task_id} - Add Proof of Delivery
                  </Typography>
                </Link>
              </div>
              <div className={css.pocWrapper}>
                {!getCompleteStatus && taskIsCompleted === false && (
                  <Chip
                    label="Add"
                    variant="outlined"
                    clickable={true}
                    className={css.uploadButton}
                    onClick={() => setopenModal(true)}
                  />
                )}
                {(!getCompleteStatus || !taskIsCompleted) && <Divider className={css.divider} />}
              </div>
            </div>
          </Accordion.Header>
        </Accordion>
        <Footer
          createdDate={props.taskData.created_at as Date}
          updatedDate={props.taskData.updated_at as Date}
        />
        {openModal && (
          <AddProofOfDeliveryModal
            open={openModal}
            onClose={() => setopenModal(false)}
            sendStatusToCard={handleStatusFromModal}
            taskId={taskData.task_id as string}
            taskName="Proof of Delivery"
            onComplete={props.onComplete}
          />
        )}
      </div>
    </>
  );
};

export default AddProofOfDelivery;
